var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-navbar-actions"},[_c('profile-dropdown',{staticClass:"app-navbar-actions__item app-navbar-actions__item--profile"},[_c('span',[_vm._v(_vm._s(_vm.userName))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }